import { useEffect, useRef } from "react";

// Adds .in class to elements with .reveal as they enter the viewport.
export function useReveal(dep) {
  const rootRef = useRef(null);

  useEffect(() => {
    const root = rootRef.current || document;
    const items = Array.from(
      root.querySelectorAll(
        ".reveal, .reveal-left, .reveal-right, .reveal-scale, .reveal-blur, .re-underline"
      )
    ).filter((el) => !el.classList.contains("in"));
    if (!("IntersectionObserver" in window)) {
      items.forEach((el) => el.classList.add("in"));
      return;
    }
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            e.target.classList.add("in");
            io.unobserve(e.target);
          }
        });
      },
      { threshold: 0.14, rootMargin: "0px 0px -40px 0px" }
    );
    items.forEach((el) => io.observe(el));
    return () => io.disconnect();
  }, [dep]);

  return rootRef;
}
